import { render, staticRenderFns } from "./registerUserDetailBox.vue?vue&type=template&id=b8b5f276"
import script from "./registerUserDetailBox.vue?vue&type=script&lang=js"
export * from "./registerUserDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports